<template>
  <div class="ticket">
    <KTCodePreview v-bind:title="'Dánh sách các phiếu yêu cầu hỗ trợ'">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3">
            <b-button
              variant="primary"
              size="sm"
              @click="openCreateStockTransfer"
            >
              <i class="flaticon2-add-1"></i> Tạo lệnh điều hàng
            </b-button>
          </div>
          <div class="ml-3">
            <b-dropdown
              v-if="canImport || canExport"
              size="sm"
              id="dropdown-ticket-action"
              right
            >
              <template slot="button-content">
                <i style="font-size: 1rem" class="fas fa-cog"></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item v-if="canImport" @click="goToImportStockTransfer">
                <span>
                  <i style="font-size: 1rem" class="fas fa-file-upload"></i>
                  &nbsp; Import Yêu cầu điều hàng
                </span>
              </b-dropdown-item>
              <b-dropdown-item v-if="canExport" @click="onOpenExportModal">
                <span>
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Xuất Excel
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <!-- Header session -->
        <div class="col-md-12 mb-5">
          <b-form>
            <b-row class="mb-5">
              <b-col class="pl-0" md="3">
                <div class="date-style">
                  <b-input-group>
                    <date-picker
                      placeholder="Từ ngày"
                      class="form-control form-control-sm"
                      :config="dpConfigs.date"
                      v-model="fromDate"
                    ></date-picker>
                  </b-input-group>
                  <span class="ml-1 mr-1"></span>
                  <b-input-group>
                    <date-picker
                      placeholder="Đến ngày"
                      class="form-control form-control-sm"
                      :config="dpConfigs.date"
                      v-model="toDate"
                    ></date-picker>
                  </b-input-group>
                </div>
              </b-col>
              <b-col md="3">
                <b-input
                  v-model="id"
                  placeholder="Nhập ID phiếu yêu cầu"
                  size="sm"
                ></b-input>
              </b-col>
              <b-col md="3">
                <b-input
                  v-model="search"
                  placeholder="Nhập thông tin cần tìm kiếm (sdt,...)"
                  size="sm"
                ></b-input>
              </b-col>
              <b-col md="3">
                <treeselect
                  :options="listTicketType"
                  :multiple="false"
                  placeholder="Chọn loại phiếu"
                  noResultsText="Không có kết quả"
                  :match-keys="['label']"
                  openDirection="bottom"
                  :clearable="false"
                  v-model="selectedTicketType"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col class="pl-0" md="3">
                <b-form-select
                  size="sm"
                  required
                  class="select-style"
                  placeholder="Chọn trạng thái"
                  v-model="selectedStatus"
                  :options="listStatus"
                  value-field="id"
                  text-field="name"
                  disabled-field="notEnabled"
                  filter
                ></b-form-select>
              </b-col>
              <b-col md="3">
                <BDropdownCustom
                  v-model="filterStore"
                  :options="storeOptions"
                  :placeholder="'cửa hàng'"
                  :matchKey="['name', 'shortName']"
                  :searchable="true"
                  :compareById="true"
                  :limit="5"
                />
              </b-col>
              <b-col md="3">
                <BDropdownCustom
                  v-model="filterCreator"
                  :options="creatorOptions"
                  :placeholder="'người tạo'"
                  :matchKey="['name', 'code', 'username', 'userIdText']"
                  :searchable="true"
                  :compareById="true"
                  :limit="5"
                >
                  <template #text="{ item }">
                    <span class="ml-1 align-middle">
                      {{ item.baseName }}
                      <span v-if="item.isResigned" class="assignee-resigned">
                        (đã nghỉ)
                      </span>
                    </span>
                  </template>
                </BDropdownCustom>
              </b-col>
              <b-col md="3">
                <BDropdownCustom
                  v-model="filterAssignee"
                  :options="assigneeOptions"
                  :placeholder="'người hỗ trợ'"
                  :matchKey="['name', 'code', 'username', 'userIdText']"
                  :searchable="true"
                  :compareById="true"
                  :limit="5"
                >
                  <template #text="{ item }">
                    <span class="ml-1 align-middle">
                      {{ item.baseName }}
                      <span v-if="item.isResigned" class="assignee-resigned">
                        (đã nghỉ)
                      </span>
                    </span>
                  </template>
                </BDropdownCustom>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col class="pl-0" md="1">
                <SaveButton
                  text="Lọc"
                  type="button"
                  :is-busy="onLoading"
                  @click="onFilter"
                />
              </b-col>
            </b-row>
          </b-form>
        </div>
        <!-- End of Header session -->
        <b-row>
          <b-col cols="12">
            <b-table :items="items" :fields="fields" bordered :busy="onLoading">
              <template v-slot:table-busy>
                <vcl-table :speed="5" :animate="true" :columns="8"></vcl-table>
              </template>

              <template v-slot:cell(userCreateTicket)="row">
                <div class="text-center" v-if="row.item.userCreateTicket">
                  <p class="mb-0">
                    {{ row.item.userCreateTicket.employee.fullName }}
                  </p>
                  <p
                    class="mb-0"
                    v-if="row.item.userCreateTicket.employee.code"
                  >
                    {{ row.item.userCreateTicket.employee.code }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(summary)="row">
                <span class="sumary-text"> {{ row.item.summary }} </span>
              </template>

              <template v-slot:cell(store)="row">
                <div v-if="isStockTransferRow(row.item)">
                  <div>
                    <span class="font-weight-bold">Nguồn (gửi):</span>
                    {{ senderStoreName(row.item) }}
                  </div>
                  <div>
                    <span class="font-weight-bold">Đích (nhận):</span>
                    {{ row.item.sourceStoreName || '--' }}
                  </div>
                </div>
                <span
                  v-else-if="
                    row.item.userCreateTicket &&
                      row.item.userCreateTicket.employee.store
                  "
                >
                  {{ row.item.userCreateTicket.employee.store.name }}
                </span>
              </template>

              <template v-slot:cell(userAssigneeTicket)="row">
                <div class="text-center" v-if="row.item.userAssigneeTicket">
                  <p class="mb-0">
                    {{ row.item.userAssigneeTicket.employee.fullName }}
                  </p>
                  <p
                    class="mb-0"
                    v-if="row.item.userAssigneeTicket.employee.code"
                  >
                    {{ row.item.userAssigneeTicket.employee.code }}
                  </p>
                </div>
                <div class="text-center" v-else>
                  <p class="mb-0">--</p>
                </div>
              </template>

              <template v-slot:cell(status)="row">
                <div class="text-center">
                  <span
                    style="width: max-content"
                    v-bind:class="{
                      'badge badge-warning text-white':
                        row.item.status === TICKET_STATUS.NEW,
                      'badge badge-primary text-white':
                        row.item.status === TICKET_STATUS.RECORDED_INFOMATION,
                      'badge badge-light':
                        row.item.status === TICKET_STATUS.PROCESSING,
                      'badge badge-success':
                        row.item.status === TICKET_STATUS.COMPLETED,
                      'badge badge-dark':
                        row.item.status === TICKET_STATUS.REJECT,
                    }"
                  >
                    {{ TICKET_STATUS_NAME[row.item.status] }}
                  </span>
                </div>
              </template>

              <template v-slot:cell(actions)="row">
                <b-dropdown
                  size="sm"
                  class="ticket-action-menu"
                  toggle-class="ticket-action-trigger"
                  no-caret
                  right
                >
                  <template slot="button-content">
                    <i class="flaticon2-settings" aria-hidden="true"></i>
                    <span class="sr-only">Mở menu thao tác phiếu</span>
                  </template>
                  <b-dropdown-item
                    class="ticket-action-item"
                    @click="detailItem(row.item)"
                  >
                    <span class="ticket-action-icon ticket-action-icon--detail">
                      <i class="fas fa-eye" aria-hidden="true"></i>
                    </span>
                    <span class="ticket-action-copy">
                      <span class="ticket-action-label">Chi tiết</span>
                      <span class="ticket-action-description">
                        Xem đầy đủ thông tin
                      </span>
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="ticket-action-item"
                    @click="editItem(row.item)"
                  >
                    <span class="ticket-action-icon ticket-action-icon--status">
                      <i class="fas fa-sync-alt" aria-hidden="true"></i>
                    </span>
                    <span class="ticket-action-copy">
                      <span class="ticket-action-label">Đổi trạng thái</span>
                      <span class="ticket-action-description">
                        Cập nhật tiến độ xử lý
                      </span>
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <div class="paging">
          <div class="total">
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số:
              {{ totalItems }}
            </p>
          </div>
          <div class="paging-nav">
            <b-pagination-nav
              class="custom-pagination"
              :link-gen="linkGen"
              v-show="totalPages >= 2"
              :number-of-pages="totalPages"
              use-router
              @change="fetchListTicket"
              first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
              prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
              next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
              last-class="page-item-last btn btn-icon btn-sm my-1 "
              page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
            >
              <template v-slot:first-text>
                <span>
                  <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                </span>
              </template>

              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>

              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>

              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </div>
        </div>
        <b-col></b-col>
        <b-col></b-col>

        <!-- Cấu hình chức vụ - số giờ công -->
        <div class="add-model">
          <b-modal ref="my-modal" hide-footer title="Cập nhật trạng thái phiếu">
            <b-row>
              <b-col>
                <b-form-group>
                  <label>Trạng thái</label>
                  <treeselect
                    :options="statusOptions"
                    :multiple="false"
                    placeholder="Chọn trạng thái"
                    noResultsText="Không có kết quả"
                    :match-keys="['label']"
                    openDirection="bottom"
                    :clearable="false"
                    v-model="ticketUpdate.status"
                  >
                    <label
                      slot="option-label"
                      slot-scope="{ node, labelClassName }"
                      :class="labelClassName"
                    >
                      <span :title="node.label"> {{ node.label }}</span>
                    </label>
                  </treeselect>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- STOCK_TRANSFER: hoàn thành cần mã phiếu chuyển kho -->
            <b-row
              v-if="
                isStockTransferUpdate &&
                  ticketUpdate.status === TICKET_STATUS.COMPLETED
              "
            >
              <b-col>
                <b-form-group>
                  <label>Mã phiếu chuyển kho (stockSlipId)</label>
                  <b-form-input
                    size="sm"
                    placeholder="Nhập mã phiếu chuyển kho"
                    v-model="ticketUpdate.stockSlipId"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- STOCK_TRANSFER: từ chối cần loại lý do -->
            <b-row
              v-if="
                isStockTransferUpdate &&
                  ticketUpdate.status === TICKET_STATUS.REJECT
              "
            >
              <b-col>
                <b-form-group>
                  <label>Lý do từ chối</label>
                  <treeselect
                    :options="rejectReasonOptions"
                    :multiple="false"
                    placeholder="Chọn lý do từ chối"
                    noResultsText="Không có kết quả"
                    :match-keys="['label']"
                    openDirection="bottom"
                    v-model="ticketUpdate.rejectReasonType"
                  />
                </b-form-group>
                <b-form-group
                  v-if="
                    ticketUpdate.rejectReasonType ===
                      STOCK_TRANSFER_REJECT_REASON.HAS_ORDER_ID
                  "
                >
                  <label>Mã đơn hàng ID</label>
                  <b-form-input
                    size="sm"
                    placeholder="Nhập mã đơn hàng ID"
                    v-model="ticketUpdate.orderId"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="
                    ticketUpdate.rejectReasonType ===
                      STOCK_TRANSFER_REJECT_REASON.OTHER
                  "
                >
                  <label>Lý do khác</label>
                  <b-form-textarea
                    size="sm"
                    :placeholder="'Nhập lý do'"
                    :rows="4"
                    :max-rows="6"
                    v-model="ticketUpdate.reason"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Các loại phiếu khác: lý do từ chối dạng text -->
            <b-row
              v-if="
                !isStockTransferUpdate &&
                  ticketUpdate.status === TICKET_STATUS.REJECT
              "
            >
              <b-col>
                <b-form-group>
                  <label>Lý do từ chối</label>
                  <b-form-textarea
                    size="sm"
                    class="input-style"
                    :placeholder="'Thêm lý do từ chối'"
                    :rows="6"
                    :max-rows="6"
                    v-model="ticketUpdate.reason"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button
              class="mt-2"
              variant="btn btn-primary"
              block
              @click="onSaveModal"
              >Lưu</b-button
            >

            <b-button
              class="mt-3"
              variant="btn btn-outline-secondary"
              block
              @click="hideModal"
              >Đóng</b-button
            >
          </b-modal>
        </div>
      </template>
    </KTCodePreview>
    <DetailTicket
      :params="ticket"
      :image="attachments"
      @getListTicket="handleGetListTicket"
    />
    <CreateStockTransferModal
      ref="createStockTransfer"
      @created="handleGetListTicket"
    />
    <TicketExportExcel
      ref="exportExcelModal"
      :apiParams="exportParams"
    />
  </div>
</template>

<style scoped>
.paging {
  display: flex;
  justify-content: space-between;
}
.date-style {
  display: flex;
  align-items: center;
}
.assignee-resigned {
  color: #f64e60;
  font-weight: 500;
}
.dropdown-item.selected .assignee-resigned {
  color: #ffe2e5;
}
.form-group label {
  font-weight: 500;
}
.submit-config button {
  font-weight: 600;
  width: 70px;
}
.submit-config button:nth-child(2) {
  margin-left: 10px;
}
.transport-config-header {
  display: flex;
  margin-bottom: 1rem;
  justify-content: flex-end;
}
.sumary-text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ticket-action-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  line-height: 1.25;
}

.ticket-action-label {
  color: #3f4254;
  font-size: 0.875rem;
  font-weight: 600;
}

.ticket-action-description {
  margin-top: 0.2rem;
  color: #7e8299;
  font-size: 0.75rem;
  font-weight: 400;
}

.ticket-action-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.ticket-action-icon--detail {
  color: #3699ff;
  background: #eaf4ff;
}

.ticket-action-icon--status {
  color: #8950fc;
  background: #f2ecff;
}

.ticket /deep/ .ticket-action-menu .ticket-action-trigger {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  align-items: center;
  justify-content: center;
  color: #5e6278;
  background: #f3f6f9;
  border: 1px solid transparent;
  border-radius: 0.625rem;
  box-shadow: none;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
}

.ticket /deep/ .ticket-action-menu .ticket-action-trigger i {
  padding: 0;
  font-size: 1rem;
}

.ticket /deep/ .ticket-action-menu .ticket-action-trigger:hover,
.ticket /deep/ .ticket-action-menu.show .ticket-action-trigger {
  color: #3699ff;
  background: #eaf4ff;
  border-color: #cfe7ff;
}

.ticket /deep/ .ticket-action-menu .ticket-action-trigger:focus {
  box-shadow: 0 0 0 3px rgba(54, 153, 255, 0.18);
}

.ticket /deep/ .ticket-action-menu .dropdown-menu {
  min-width: 15rem;
  padding: 0.5rem;
  margin-top: 0.5rem;
  border: 1px solid #eef0f4;
  border-radius: 0.75rem;
  box-shadow: 0 0.75rem 2rem rgba(31, 45, 61, 0.14);
}

.ticket /deep/ .ticket-action-menu .dropdown-item {
  display: flex;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  align-items: center;
  color: #3f4254;
  border-radius: 0.5rem;
  white-space: normal;
  transition: background-color 0.15s ease;
}

.ticket /deep/ .ticket-action-menu .dropdown-item:hover,
.ticket /deep/ .ticket-action-menu .dropdown-item:focus {
  color: #3f4254;
  background: #f5f8fa;
}

.ticket
  /deep/
  .ticket-action-menu
  .dropdown-item:hover
  .ticket-action-icon--detail,
.ticket
  /deep/
  .ticket-action-menu
  .dropdown-item:focus
  .ticket-action-icon--detail {
  color: #ffffff;
  background: #3699ff;
}

.ticket
  /deep/
  .ticket-action-menu
  .dropdown-item:hover
  .ticket-action-icon--status,
.ticket
  /deep/
  .ticket-action-menu
  .dropdown-item:focus
  .ticket-action-icon--status {
  color: #ffffff;
  background: #8950fc;
}

.ticket /deep/ .vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  height: 2.5rem;
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import timeUtils from '@/utils/date';

import { VclTable } from 'vue-content-loading';

import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import DetailTicket from './Detail.vue';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import SaveButton from '@/view/components/common/SaveButton.vue';
import CreateStockTransferModal from '@/view/components/ticket/CreateStockTransferModal.vue';
import TicketExportExcel from '@/view/components/ticket/TicketExportExcel.vue';
import { checkPermissions } from '@/utils/saveDataToLocal';
import { TICKET_STATUS_NAME } from '@/utils/enum-name';
import {
  FUNCTION_ACTION_TICKET,
  TICKET_STATUS,
  STOCK_TRANSFER_REJECT_REASON,
} from '@/utils/enum';
import {
  buildTicketStatusUpdatePayload,
  createTicketStatusUpdate,
  isStockTransferStatusUpdate,
  STOCK_TRANSFER_REJECT_REASON_OPTIONS,
  TICKET_STATUS_OPTIONS,
} from './ticket-status-update';
import axios from 'axios';
import { cmdUrl } from '@/utils/apiUrl';
import JwtService from '@/core/services/jwt.service';
export default {
  components: {
    KTCodePreview,
    Treeselect,
    VclTable,
    BDropdownCustom,
    SaveButton,
    DetailTicket,
    CreateStockTransferModal,
    TicketExportExcel,
  },
  data() {
    return {
      TICKET_STATUS_NAME,
      TICKET_STATUS,
      // Chụp bộ lọc lúc mở modal; modal giữ nguyên tới lúc bấm Xuất, không đọc lại state màn.
      exportParams: {},
      //  Bộ lọc của lần nạp danh sách GẦN NHẤT — xem `onOpenExportModal`.
      appliedFilterParams: null,
      FUNCTION_ACTION_TICKET,
      STOCK_TRANSFER_REJECT_REASON,
      statusOptions: TICKET_STATUS_OPTIONS,
      stores: [],
      storeOptions: [],
      totalPages: 1,
      totalItems: 0,
      page: 1,
      currentPage: 1,
      items: [],
      id: '',
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '10%',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
        {
          key: 'TicketTypeSetting.name',
          label: 'Loại phiếu',
          thStyle: { color: '#181c32', width: '280px' },
        },
        {
          key: 'userCreateTicket',
          label: 'Người tạo',
          thStyle: { color: '#181c32', width: '240px', textAlign: 'center' },
        },
        {
          key: 'summary',
          label: 'Nội dung',
          thStyle: { color: '#181c32', width: '480px', textAlign: 'center' },
        },
        {
          key: 'store',
          label: 'Cửa hàng',
          thStyle: { color: '#181c32', width: '240px', textAlign: 'center' },
        },
        {
          key: 'userAssigneeTicket',
          label: 'Người hỗ trợ',
          thStyle: { color: '#181c32', width: '240px', textAlign: 'center' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { color: '#181c32', width: '120px', textAlign: 'center' },
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'text-center',
          thStyle: {
            width: '5%',
          },
        },
      ],
      selectedStatus: -1,
      listStatus: [
        { id: -1, name: 'Chọn trạng thái' },
        { id: 0, name: 'Mới' },
        { id: 1, name: 'Ghi nhận thông tin' },
        { id: 2, name: 'Đang xử lí' },
        { id: 3, name: 'Hoàn thành' },
        { id: 4, name: 'Từ chối' },
      ],
      selectedTicketType: -1,
      listTicketType: [{ id: -1, label: 'Chọn loại phiếu' }],
      limit: 10,
      onSaving: false,
      onLoading: false,
      search: '',
      fromDate: '',
      toDate: '',
      dpConfigs: timeUtils.DP_CONFIG,
      filterAssignee: [],
      assigneeOptions: [],
      filterCreator: [],
      creatorOptions: [],
      filterStore: [],
      ticket: null,
      ticketUpdate: createTicketStatusUpdate(),
      rejectReasonOptions: STOCK_TRANSFER_REJECT_REASON_OPTIONS,
      attachments: [],
    };
  },
  computed: {
    isStockTransferUpdate() {
      return isStockTransferStatusUpdate(this.ticketUpdate);
    },
    //  Ẩn mục cho khớp gác quyền phía BE (`stock-transfer-import.controller.js` và 5 route
    //  `/tickets/export*`). Ẩn chỉ để đỡ khó hiểu — chặn thật vẫn nằm ở server.
    canImport() {
      return checkPermissions(['TICKET_IMPORT']);
    },
    canExport() {
      return checkPermissions(['TICKET_EXPORT']);
    },
  },
  created() {
    this.fetchListTicket();
    this.fetchListTypeTicket();
    this.fetchListAssignee();
    this.fetchListCreator();
    this.fetchListStore();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Danh sách phiếu yêu cầu hỗ trợ',
        route: 'ticket',
      },
    ]);
  },
  methods: {
    updateStatus() {
      const { payload, error } = buildTicketStatusUpdatePayload(
        this.ticketUpdate,
      );
      if (error) {
        makeToastFaile(error);
        return;
      }

      ApiService.post('/v2/tickets/update', payload)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 200) {
            this.fetchListTicket();
            makeToastSuccess(message);
            this.hideModal();
          } else {
            makeToastFaile(message);
          }
        })
        .catch(({ response }) => {
          console.log({ response });
          const { message } = response.data;
          makeToastFaile(message);
        });
    },

    showModal() {
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    onSaveModal() {
      this.updateStatus();
    },
    handleGetListTicket() {
      this.fetchListTicket();
    },
    openCreateStockTransfer() {
      this.$refs.createStockTransfer.show();
    },
    goToImportStockTransfer() {
      this.$router
        .push({ name: 'import-stock-transfer-ticket' })
        .catch(() => {});
    },
    /**
     * Mở modal xuất Excel với ĐÚNG bộ lọc bảng đang hiển thị (`appliedFilterParams`), không
     * phải v-model sống — sửa ô lọc mà chưa bấm Lọc thì bảng vẫn là dữ liệu cũ.
     *
     * Dùng component RIÊNG `TicketExportExcel`, không dùng `ExportExcelModal` chung: file giờ
     * build ở nền rồi tải từ bảng lịch sử, sửa modal chung theo luồng mới sẽ gãy
     * `stocks/ListProductRequire.vue` — consumer duy nhất còn lại của nó.
     */
    onOpenExportModal() {
      const filterParams = this.appliedFilterParams || this.buildFilterParams();
      if (!filterParams) return;
      this.exportParams = filterParams;
      this.$refs.exportExcelModal.showModal();
    },
    isStockTransferRow(item) {
      return (
        item.TicketTypeSetting &&
        item.TicketTypeSetting.functionAction ===
          FUNCTION_ACTION_TICKET.STOCK_TRANSFER
      );
    },
    senderStoreName(item) {
      if (
        item.TicketStores &&
        item.TicketStores.length &&
        item.TicketStores[0].Store
      ) {
        return item.TicketStores[0].Store.name;
      }
      return '--';
    },
    onFilter() {
      if (this.$route.query.page) {
        this.$router.replace({ query: {} }).catch(() => {});
      }
      this.fetchListTicket(1);
    },
    /**
     * Bộ lọc đang áp, KHÔNG kèm phân trang. Dùng chung cho danh sách và Xuất Excel để hai
     * chỗ không trôi lệch. Trả `null` khi khoảng ngày không hợp lệ (đã toast sẵn).
     */
    buildFilterParams() {
      const fromDate = timeUtils.formatSpecificDate(
        this.fromDate,
        timeUtils.DATE_FORMAT,
        timeUtils.YEAR_MONTH_DAY_FORMAT,
      );
      const toDate = timeUtils.formatSpecificDate(
        this.toDate,
        timeUtils.DATE_FORMAT,
        timeUtils.YEAR_MONTH_DAY_FORMAT,
      );
      if (fromDate && toDate && timeUtils.checkIsAfterTime(fromDate, toDate)) {
        makeToastFaile('Từ ngày không được lớn hơn Đến ngày');
        return null;
      }

      const param = {
        search: this.search,
        id: this.id,
        fromDate,
        toDate,
      };

      if (this.selectedTicketType !== -1) {
        param['type'] = this.selectedTicketType;
      }
      if (this.selectedStatus !== -1) {
        param['status'] = this.selectedStatus;
      }
      if (this.filterAssignee.length) {
        param['assigneeIds'] = this.filterAssignee.map((item) => item.id);
      }
      if (this.filterCreator.length) {
        param['creatorIds'] = this.filterCreator.map((item) => item.id);
      }
      if (this.filterStore.length) {
        param['storeIds'] = this.filterStore.map((item) => item.id);
      }
      return param;
    },
    fetchListTicket: async function(pageNumber) {
      const filterParams = this.buildFilterParams();
      if (!filterParams) return;
      //  Chốt lại đúng bộ lọc vừa dùng để nạp bảng — Xuất Excel bám vào cái này.
      this.appliedFilterParams = filterParams;

      this.page = pageNumber || this.$route.query.page || 1;
      this.onLoading = true;
      const param = {
        ...filterParams,
        page: this.page,
        pageSize: 10,
      };
      const paramQuery = {
        params: param,
      };

      ApiService.query('/v2/tickets', paramQuery)
        .then((response) => {
          const dataResponse = response.data.data;
          this.items = [];
          this.totalPages =
            dataResponse.totalPage > 0 ? dataResponse.totalPage : 1;
          this.totalItems = dataResponse.totalRow;
          this.currentPage = param.page;
          this.items = [...dataResponse.dataset];
        })
        .catch(({ response }) => {
          const message =
            response && response.data
              ? response.data.message
              : 'Không tải được danh sách phiếu';
          makeToastFaile(message);
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    async fetchListStore() {
      ApiService.get('stores/getStores')
        .then((response) => {
          const dataResponse = response.data.data || [];
          this.storeOptions = dataResponse.map((item) => ({
            id: item.id,
            name: item.shortName
              ? `${item.name} (${item.shortName})`
              : item.name,
            shortName: item.shortName || '',
          }));
        })
        .catch(() => {
          makeToastFaile('Không tải được danh sách cửa hàng');
        });
    },
    mapUserOption(item) {
      const label = item.code
        ? `${item.fullName} (${item.code})`
        : item.fullName;
      return {
        id: item.id,
        name: `${label}${item.isResigned ? ' (đã nghỉ)' : ''}`,
        baseName: label,
        isResigned: !!item.isResigned,
        code: item.code || '',
        username: item.username || '',
        userIdText: String(item.id),
        shortName: item.code || item.username || `#${item.id}`,
      };
    },
    // Chỉ những người thực sự có mặt ở cột tương ứng của phiếu, nên gồm cả tài khoản
    // hệ thống và người đã nghỉ việc.
    async fetchUserOptions(url, errorMessage) {
      try {
        const response = await ApiService.get(url);
        const dataResponse = response.data.data || [];
        return dataResponse.map((item) => this.mapUserOption(item));
      } catch (e) {
        makeToastFaile(errorMessage);
        return [];
      }
    },
    async fetchListAssignee() {
      this.assigneeOptions = await this.fetchUserOptions(
        '/v2/tickets/assignees',
        'Không tải được danh sách người hỗ trợ',
      );
    },
    async fetchListCreator() {
      this.creatorOptions = await this.fetchUserOptions(
        '/v2/tickets/creators',
        'Không tải được danh sách người tạo',
      );
    },
    async fetchListTypeTicket() {
      ApiService.get('/v2/tickets/type').then((response) => {
        const dataResponse = response.data.data;
        for (const item of dataResponse) {
          this.listTicketType.push({ id: item.code, label: item.name });
        }
      });
    },
    editItem: function(item) {
      if (item) {
        this.ticketUpdate = createTicketStatusUpdate(item);
        this.showModal();
      }
    },
    detailItem: async function(item) {
      this.ticket = item;
      const listImage = JSON.parse(this.ticket.extra);
      if (listImage && listImage.length) {
        await this.getImage(listImage);
      }
      this.$bvModal.show('detail-ticket');
    },
    async getImage(image) {
      this.attachments = await Promise.all(
        image.map(async (item) => {
          const fileName = item;
          const resp = await axios.get(
            `${cmdUrl.File.download}?filename=${fileName}`,
            {
              responseType: 'arraybuffer',
              headers: {
                Authorization: `Bearer ${JwtService.getToken()}`,
              },
            },
          );
          const contentType = resp.headers['content-type'];
          const base64 = `data:${contentType};base64,${Buffer.from(
            resp.data,
          ).toString('base64')}`;
          return {
            url: base64,
            fileName,
          };
        }),
      );
    },
  },
};
</script>
